module.exports = __webpack_public_path__ + "static/media/8.5a4e99d8.jpeg";